import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import notice from './modules/notice'
import role from './modules/role'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    notice,
    role
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js